<template>
  <el-timeline>
    <el-timeline-item :color="item.size === 'large' ? '#409EFF': '#e4e7ed'" :size="item.size"
                      :timestamp="item.updateTime" placement="top" v-for="item in logData">
      <el-card>
        <h3>{{ item.version }}</h3>
        <h4 v-if="item.update && item.update.length > 0">商务管理系统更新:</h4>
        <ul>
          <li class="logDetail" v-for="(itemInner,index) in item.update"><i
              class="iconfont icon-dian"></i>{{ index + 1 }}、{{ itemInner }}
          </li>
        </ul>
        <h4 v-if="item.optimize && item.optimize.length > 0">商务管理系统优化:</h4>
        <ul>
          <li v-for="(itemInner,index) in item.optimize"><i class="iconfont icon-dian"></i>{{ index + 1 }}、{{
              itemInner
            }}
          </li>
        </ul>
      </el-card>
    </el-timeline-item>
  </el-timeline>
</template>

<script>
import {logsData} from "@/utils/logsData";

export default {
  name: 'updateLog',
  data() {
    return {
      logData:logsData
    }
  },
}
</script>

<style scoped>

h3 {
  margin-top: 0;
  font-size: 25px;
}

h4 {
  font-size: 16px;
}


.el-card ul li {
  margin-top: 5px;
  font-weight: 550;
  font-size: 14px;
  word-wrap: break-word;
}
</style>
